import React, { useEffect, useRef, useState } from 'react'
import { Row, Col, Form, Card, Button, Divider, Modal, message } from 'antd'
import { connect, useDispatch, useSelector } from 'react-redux'

import InputField from 'components/InputField'
import TextAreaField from 'components/TextArea'
import SelectField from 'components/SelectField'
import FileUpload from 'components/fileUpload'

import {
  SaveIco,
  SaveBlueIco,
  RefreshIco,
  SearchIco,
  MinusSmallIco,
  PlusSmallIco,
  InputSearchIco,
  ModalCloseIco,
  DocumentsIco,
  EroorIco,
} from '../../../../../modules/CustomIcons'

import './index.scss'
import '../../transfer.scss'
import { OWNACCOUNT } from 'constants/constants'
import {
  Account,
  getAccounts,
  getSavedDocuments,
} from '../../../../services/account'
import { SelectOptions } from '../../../../services/form'
import { getCurrentCompany, getUserData } from '../../../../services/user'
import {
  checkAmountForRequest,
  fillCurrentForm,
  fillCurrentFormTemplate,
  financial,
  resetForm,
} from '../../../../services/helper'
import AmountField from 'components/AmountField'
import NextModal from 'components/NextModal'
import { BicCodes, getBicCodes } from '../../../../services/moneytransfer'
import { getRubDocumentNumber } from '../../../../services/Accounts/DocumentNumber'
import { newMoneyTransferSwiftRub } from '../../../../services/Transfers/SwiftRub'
import TemplatePopup from 'components/TemplatePopup'
import { getCustomerCommission } from '../../../../services/Customers/Commission'
import SaveAsTemplate from 'components/SaveAsTemplate'
import { useLocation } from 'react-router-dom'
import { newMoneyTransferAzips } from '../../../../services/Transfers/Azips'
import { setIbanNumber } from '../../../../store/actions/accountStatement'
import { useActions } from 'hooks/useActions'
import { useTranslation } from 'react-i18next'
import ModalComponent from 'components/Modal'
import DocumentsModal from 'components/DocumentsModal'
import moment from 'moment'
import FormItem from 'antd/es/form/FormItem'
import {  deleteFileById  } from '../../../../services/Transfers/Files'
import DgkModal from 'components/DGKmodals/DgkModal'
import { setDgkData } from '../../../../store/actions/DGK'
import { GetInfByGBNO, GetInfByPinCode } from '../../../../services/Transfers/dgk'
import FullScreenLoading from 'components/FullScreenLoading'

const kppInitial = {
  required: false,
  readOnly: true,
}

const Rub: React.FC<any> = ({ ownProps, ibanNumber }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  interface DataType {
    key: string
    docId: React.Key
    docName: string
    docNumAbsent: boolean
    docNum: string
    docDate: string
    docNote: string
    isUsed: Boolean
    }

  const modalDataInitial = {
    modalTitle: t('home.foreignCurrencyTransfer'),
    groups: [],
    pdfFiles: [],
    buttons: [
      { save: true },
      { sign: true },
      { approve: true },
      { send: true },
    ],
    rubNote:
      '<b style="text-align: center">Müştərinin nəzərinə! / To the attention of customer!</b>' +
      '<br>' +
      'Ödəniş tapşırığında köçürüləcək vəsaitə münasibətdə, beynəlxalq sanksiya nəticəsində tətbiq oluna biləcək məhdudiyyət, vəsaitin dondurulması/əməliyyatın icra olunmaması ehtimalından xəbərdaram. ' +
      'Müxbir bankın sorğusu əsasında beynəlxalq ödənişlər üzrə Bank tərəfindən fərdi məlumatlarımın ötürülməsinə və ödəniş tapşırığı ölkə qanunvericiliyi, bankdaxili qaydalara əsasən yoxlamalardan keçdikdən sonra ümumən Banka daxil olduqdan sonrakı 3 iş günü ərzində icra olunmasına razılığımı bildirirəm. \n' +
      '<br>' +
      'I am aware of the possibility of limiting, freezing/non-execution of a transaction that may be applied as a result of international sanctions in relation to funds under a payment order. ' +
      'I agree to the transfer of my personal data by the Bank to payments based on the request of the correspondent bank and I agree that the payment order will be executed within 3 business days after it is received by the Bank in general, passing the checks in accordance with the country\'s legislation and the Bank\'s internal procedures. ' +
      'This consent confirms that I will not claim against the Bank in future.',
  }

  const dataDocumentModal: DataType[] = [
    {
      key: '1',
      docId: '1',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      isUsed: false,
    },
    {
      key: '2',
      docId: '2',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      isUsed: false,
    },
    {
      key: '3',
      docId: '3',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      isUsed: false,
    },
    {
      key: '4',
      docId: '4',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      isUsed: false,
    },
    {
      key: '5',
      docId: '5',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      isUsed: false,
    },
    {
      key: '6',
      docId: '6',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      isUsed: false,
    },
    {
      key: '7',
      docId: '7',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      isUsed: false,
    },
    {
      key: '8',
      docId: '8',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      isUsed: false,
    },
    {
      key: '9',
      docId: '9',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      isUsed: false,
    },
    {
      key: '10',
      docId: '10',
      docName: '',
      docNumAbsent: false,
      docNum: '',
      docDate: '',
      docNote: '',
      isUsed: false,
    },
  ]

  const itemsRub = [
    {
      label: 'Договор',
      value: 'Dogov',
      code: 'ДОГОВ',
    },
    {
      label: 'Инвойс',
      value: 'Inv',
      code: 'ИНВ',
    },
    {
      label: 'Заказ на закупку',
      value: 'Zakaz na zakupku',
      code: 'ЗАК.НА ЗАКУПКУ',
    },
    {
      label: 'Дебетовое авизо',
      value: 'Debet.avizo',
      code: 'ДЕБЕТ.АВИЗО',
    },
    {
      label: 'Декларация',
      value: 'Dekl',
      code: 'ДЕКЛ',
    },
    {
      label: 'Письмо',
      value: 'Pisxmo',
      code: 'ПИСЬМО',
      },
      {
      label: 'Решение учредителей',
      value: 'Req.ucreditelei',
      code: 'РЕШ.УЧРЕДИТ.',
      },
      {
      label: 'Решение суда',
      value: 'Req.suda',
      code: 'РЕШ.СУДА',
      },
     {
      label: 'Док., подтверждающий поступл. средств',
      value: 'Dok.o postupl.sredstv',
      code: 'ДОК.О ПОСТУПЛ.СРЕДСТВ',
      },
    ]

  const paymentOptions = [
    {
      label: t('dgk.prepayment_goods'),
      value: 'PREPAY_GOODS',
    },
    {
      label: t('dgk.prepayment_service'),
      value: 'PREPAY_SERVICE',
    },
    {
      label: t('dgk.postpayment_goods'),
      value: 'POSTPAY_GOODS',
    },
    {
      label: t('dgk.postpayment_service'),
      value: 'POSTPAY_SERVICE',
    },
    {
      label: t('dgk.other'),
      value: 'OTHER',
    },
  ]

  const conditions = ['YGB', 'AKT', 'Avans']
  const [visible, setVisible] = useState(false)
  const [codeModalVisible, setCodeModalVisible] = useState(false)
  const [allAccounts, setAllAccounts] = useState<Account[]>()
  const [fromSelectOptions, setFromSelectOptions] = useState<SelectOptions[]>()
  const [fromBranch, setFromBranch] = useState<Account>()
  const [toBranch, setToBranch] = useState<BicCodes>()
  const [documentsModalVisible, setDocumentsModalVisible] = useState(false)
  const [nextModalVisible, setNextModalVisible] = useState(false)
  const [templatePopupVisible, setTemplatePopupVisible] = useState(false)
  const [saveAsTemplatePopupVisible, setSaveAsTemplatePopupVisible] =
    useState<boolean>(false)
  const [bicCodes, setBicCodes] = useState<BicCodes>()
  const [modalData, setModalData] = useState(modalDataInitial)
  const [documentNumber, setDocumentNumber] = useState<string>('')
  const [documentsModalData, setModalDataDocuments] = useState<any[]>(dataDocumentModal)
  const [formFields, setFormFields] = useState({})
  const [commissionLoading, setCommissionLoading] = useState(false)
  const [commissionAmount, setCommissionAmount] = useState('')
  const [kppRules, setKppRules] = useState(kppInitial)
  const [retryRequest, setRetryRequest] = useState<Record<string, any> | null>(null)
  const [loadingAccount, setLoadingAccount] = useState(false)
  const [loadingData, setLoadingData] = useState(false)
  const [ibankRef, setIbankRef] = useState<string>('')
  const [pdfCount, setPdfCount] = useState(0)
  const [fileList, setFileList] = useState<any[]>([])
  const [tableData, setTableData] = useState<any[]>([])
  const [editOrRepeat, setEdit] = useState(false)
  const [documentsCount, setDocumentsCount] = useState(0)
  const [savedDocuments, setSaveDocuments] = useState('')
  const cancelPMTDETRef = useRef<string | null>(null)
  const [createData, setcreateData] = useState<any[]>([])
  const [documentsData,  setDocumentsData] = useState<any[]>([])
  const [dgkModalKey, setDgkModalKey] = useState(0);
  const [form] = Form.useForm()
  const location = useLocation()
  const [paymentConditionValue, setPaymentConditionValue] = useState<string>()
  const [activeCondition, setActiveCondition] = useState<string>()
  const [openDgkModal, setOpenDgkModal] = useState<boolean>(false)
  const dgkData = useSelector((state: any) => state.dgk?.data)
  const { setIbanNumber } = useActions()

  const formatDate = (value: any, output: 'dot' | 'dash' = 'dot') => {
    if (!value) return null

    if (typeof value === 'string') {
      if (value.includes('-')) {
        const [y, m, d] = value.split('-')
        if (y && m && d) {
          return output === 'dot' ? `${d}.${m}.${y}` : `${y}-${m}-${d}`
        }
      }

      if (value.includes('.')) {
        const [d, m, y] = value.split('.')
        if (d && m && y) {
          return output === 'dash' ? `${y}-${m}-${d}` : `${d}.${m}.${y}`
        }
      }

      return value
    }

    if (value?._isAMomentObject && typeof value.format === 'function') {
      return output === 'dot'
        ? value.format('DD.MM.YYYY')
        : value.format('YYYY-MM-DD')
    }

    if (typeof value?.format === 'function') {
      return output === 'dot'
        ? value.format('DD.MM.YYYY')
        : value.format('YYYY-MM-DD')
    }

    return null
  }

  const formatDateForInput = (value: any) => {
    if (!value) return null

    if (typeof value === 'string') {
      if (value.includes('.')) {
        const [d, m, y] = value.split('.')
        if (d && m && y) return `${y}-${m}-${d}`
      }
      if (value.includes('-')) return value
    }

    return value
  }

  const mapRepeatYgbToDgkState = (data: any) => {
    const ygbList = data?.ygb || []
    if (!ygbList.length) return null

    return {
      type: 'YGB',
      iban: data?.CUSTACC ?? null,
      accountCurrency: data?.ccyType ?? fromBranch?.CCY_NAME ?? null,
      pages: ygbList.map((row: any) => ({
        key: row?.gbNumber ?? '',
        gbNo: row?.gbNumber ?? '',
        summary: {
          name: row?.customerFullname ?? null,
          taxId: row?.taxNumber ?? null,
          receiverCountry: row?.beneficiaryCountry ?? null,
          invoiceCost: row?.ygbInvoiceCost ?? null,
          operationAmount: row?.ygbOperationAmount ?? null,
          egbSum: row?.ygbRemainderAmount ?? null,
          invoiceCurrency: row?.ygbRemainderCcy ?? null,
          deliveryCondition: row?.pmtCondition ?? null,
          bargainingFeature: row?.ygbDeclareType ?? null,
          impDocDate: row?.ygbImpDocDate ?? null,
          impDocCost: row?.ygbDocCost ?? null,
          declarationTypeKey: row?.ygbDeclareTypeKey ?? null,
          senderOrExporter: row?.ygbSender ?? null,
          goodOfServiceInfo: row?.goodServiceInfo ?? null,
              note: row?.note ?? null,
              bankUserNumber: row?.bankUserNumber ?? null,
              pincode: row?.ygbPincode ?? row?.pincode ?? row?.pinCode ?? null,
            },
        form: {
          gbNo: row?.gbNumber ?? '',
          name: row?.customerFullname ?? '',
          receiverCountry: row?.beneficiaryCountry ?? '',
          invoiceCost: row?.ygbInvoiceCost ?? '',
          operationAmount: row?.ygbOperationAmount ?? '',
          egbSum: row?.ygbRemainderAmount ?? '',
          contractNo: row?.contractNumber ?? '',
          contractDate: formatDate(row?.ygbDate, 'dash'),
          receiverCountryId: row?.countryCode != null ? String(row.countryCode) : undefined,
          receiverName: row?.beneficiaryName ?? '',
          transferredAmount: row?.ygbAmount ?? '',
          currencyType: row?.ccy ?? '',
          exchange: '',
        },
        serverData: {
          gbNo: row?.gbNumber ?? '',
          name: row?.customerFullname ?? '',
          taxId: row?.taxNumber ?? null,
          receiverCountry: row?.beneficiaryCountry ?? '',
          invoiceCost: row?.ygbInvoiceCost ?? '',
          operationAmount: row?.ygbOperationAmount ?? '',
          egbSum: row?.ygbRemainderAmount ?? '',
          invoiceCurrency: row?.ygbRemainderCcy ?? '',
          deliveryCondition: row?.pmtCondition ?? null,
          bargainingFeature: row?.ygbDeclareType ?? null,
          impDocDate: row?.ygbImpDocDate ?? null,
          impDocCost: row?.ygbDocCost ?? null,
          declarationTypeKey: row?.ygbDeclareTypeKey ?? null,
          senderOrExporter: row?.ygbSender ?? null,
          goodOfServiceInfo: row?.goodServiceInfo ?? null,
          note: row?.note ?? null,
          bankUserNumber: row?.bankUserNumber ?? null,
          contracts: row?.contractNumber
            ? [
                {
                  no: row.contractNumber,
                  date: formatDate(row?.ygbDate, 'dash'),
                },
              ]
            : [],
          details: [],
          filePath: null,
        },
        docNoOptions: row?.contractNumber
          ? [
              {
                label: row.contractNumber,
                value: row.contractNumber,
              },
            ]
          : [],
      })),
    }
  }

  const mapRepeatAdvanceToDgkState = (data: any) => {
    const advanceList = data?.advance || []
    if (!advanceList.length) return null

    const pinCode = advanceList[0]?.pin ?? null
    const taxId = advanceList[0]?.taxNumber ?? null
    const name = advanceList[0]?.customerFullName ?? null

    const contracts = advanceList.map((row: any, idx: number) => ({
      id: `advance-${idx}`,
      contractNo: row?.advanceInvoiceNumber ?? '',
      contractDate: row?.advanceDate ?? '',
      accountNo: row?.accountNumber ?? '',
      countryCode: row?.country ?? undefined,
      bank: row?.beneficiaryName ?? '',
      details: row?.note
        ? [
            {
              id: `advance-detail-${idx}`,
              note: row.note,
              paymentAmount: row?.advanceAmount ?? '',
              paymentCurrency: row?.ccy ?? '',
              accountNo: row?.accountNumber ?? '',
              country: row?.country ?? '',
              bank: row?.beneficiaryName ?? '',
            },
          ]
        : [],
    }))

    const formData: Record<string, any> = {}

    advanceList.forEach((row: any, idx: number) => {
      formData[`contNo-${idx}`] = row?.advanceInvoiceNumber ?? ''
      formData[`date-${idx}`] = formatDateForInput(row?.advanceDate)
      formData[`accountNo-${idx}`] = row?.accountNumber ?? ''
      formData[`avansReceiverCountryId-${idx}`] = row?.country ?? undefined
      formData[`avansReceiver-${idx}`] = row?.beneficiaryName ?? ''
      formData[`avansTransferredAmount-${idx}`] = row?.advanceAmount ?? ''
      formData[`avansCurrencyType-${idx}`] = row?.ccy ?? ''
      formData[`avansExchange-${idx}`] = ''
    })

    return {
      type: 'Avans',
      iban: data?.CUSTACC ?? null,
      pinCode,
      summary: {
        pinCode,
        taxId,
        name,
      },
      contracts,
      details: [],
      gbList: [],
      form: formData,
    }
  }

  const mapRepeatActToDgkState = (data: any) => {
    const actList = data?.act || []
    if (!actList.length) return null

    return {
      type: 'AKT',
      iban: data?.CUSTACC ?? null,
      taxId: getCurrentCompany()?.organizationCode ,
      pages: actList.map((row: any, idx: number) => ({
        key: `akt-${idx}`,
        form: {
          actDocDate: formatDateForInput(row?.actDocDate),
          noActDocNumber: String(row?.noActDocNumber) === 'true',
          actDocNumber:
            String(row?.noActDocNumber) === 'true'
              ? undefined
              : row?.actDocNumber ?? '',
          actDocCost: row?.actDocCost ?? '',
          actTransCost: row?.actTransCost ?? '',
          currencyType: row?.ccyCode ?? '',
          actExchange: '',
          actSender: row?.actSender ?? '',
          actServiceProvider: String(row?.actServiceProvider) === 'true',
          actServiceProviderName:
            String(row?.actServiceProvider) === 'true'
              ? row?.actServiceProviderName ?? ''
              : '',
          countryId: row?.country != null ? String(row.country) : undefined,
          goodServiceInfo: row?.goodServiceInfo ?? '',
          note: row?.note ?? '',
        },
        summary: {
          actDocDate: row?.actDocDate ?? null,
          actDocNumber:
            String(row?.noActDocNumber) === 'true'
              ? null
              : row?.actDocNumber ?? null,
          actTransCost: row?.actTransCost ?? null,
          currencyType: row?.ccyCode ?? null,
        },
      })),
    }
  }

  const hydrateRepeatYgb = async (data: any) => {
    const ygbList = data?.ygb || []
    if (!ygbList.length) return null

    const pages = await Promise.all(
      ygbList.map(async (row: any) => {
        try {
          const res = await GetInfByGBNO({
            gbNo: row?.gbNumber,
            iban: data?.CUSTACC,
          })

          const api = res?.data || {}
          const contracts = api?.contracts || []
          const details = api?.details || []

          return {
            key: row?.gbNumber ?? '',
            gbNo: row?.gbNumber ?? '',
            summary: {
              name: api?.name ?? row?.customerFullname ?? null,
              taxId: api?.taxId ?? row?.taxNumber ?? null,
              receiverCountry: api?.receiverCountry ?? row?.beneficiaryCountry ?? null,
              invoiceCost: api?.invoiceCost ?? row?.ygbInvoiceCost ?? null,
              operationAmount: api?.operationAmount ?? row?.ygbOperationAmount ?? null,
              egbSum: api?.egbSum ?? row?.ygbRemainderAmount ?? null,
              invoiceCurrency: api?.invoiceCurrency ?? row?.ygbRemainderCcy ?? null,
              deliveryCondition: api?.deliveryCondition ?? row?.pmtCondition ?? null,
              bargainingFeature: api?.bargainingFeature ?? row?.ygbDeclareType ?? null,
              impDocDate: api?.impDocDate ?? row?.ygbImpDocDate ?? null,
              impDocCost: api?.impDocCost ?? row?.ygbDocCost ?? null,
              declarationTypeKey:
                api?.declarationTypeKey ?? row?.ygbDeclareTypeKey ?? null,
              senderOrExporter: api?.senderOrExporter ?? row?.ygbSender ?? null,
              goodOfServiceInfo:
                api?.goodOfServiceInfo ?? row?.goodServiceInfo ?? null,
              note: row?.note ?? api?.note ?? null,
              bankUserNumber: row?.bankUserNumber ?? null,
              pincode: api?.pincode ?? api?.pinCode ?? row?.ygbPincode ?? null,
            },
            contracts,
            details,
            filePath: api?.filePath ?? null,
            form: {
              gbNo: row?.gbNumber ?? '',
              name: api?.name ?? row?.customerFullname ?? '',
              receiverCountry: api?.receiverCountry ?? row?.beneficiaryCountry ?? '',
              invoiceCost: api?.invoiceCost ?? row?.ygbInvoiceCost ?? '',
              operationAmount: api?.operationAmount ?? row?.ygbOperationAmount ?? '',
              egbSum: api?.egbSum ?? row?.ygbRemainderAmount ?? '',
              contractNo: row?.contractNumber ?? '',
              contractDate: contracts.find((c: any) => c?.no === (row?.contractNumber ?? ''))?.date || formatDate(row?.ygbDate, 'dash') || '',
              receiverCountryId: row?.countryCode != null ? String(row.countryCode) : undefined,
              receiverName: row?.beneficiaryName ?? '',
              transferredAmount: row?.ygbAmount ?? '',
              currencyType: row?.ccy ?? '',
              exchange: '',
            },
          }
        } catch (e) {
          console.error('YGB hydrate failed', row?.gbNumber, e)
          return null
        }
      })
    )

    const filteredPages = pages.filter(Boolean)

    if (!filteredPages.length) return null

    return {
      type: 'YGB',
      iban: data?.CUSTACC ?? null,
      accountCurrency: data?.ccyType ?? null,
      pages: filteredPages,
    }
  }

  const hydrateRepeatAvans = async (data: any) => {
    const advanceList = data?.advance || []
    if (!advanceList.length) return null

    const pin = advanceList?.[0]?.pin
    if (!pin) return null

    try {
      const res = await GetInfByPinCode({
        pinCode: pin,
        iban: data?.CUSTACC,
      })

      const api = res?.data
      if (!api) return null

      const groupedContracts = (api?.contracts || []).map((contract: any, idx: number) => {
        const relatedDetails = (api?.details || []).filter(
          (d: any) =>
            String(d?.contract?.no || '') === String(contract?.no || '') &&
            String(d?.contract?.date || '') === String(contract?.date || '')
        )

        const firstDetail = relatedDetails[0]

        return {
          id: `${contract?.no || 'contract'}-${idx}`,
          contractNo: contract?.no || '',
          contractDate: contract?.date || '',
          accountNo: firstDetail?.accountNo || '',
          country: firstDetail?.country || '',
          countryCode: firstDetail?.countryCode || '',
          bank: firstDetail?.bank || '',
          details: relatedDetails,
        }
      })

      const formData: Record<string, any> = {}

      groupedContracts.forEach((contractRow: any, idx: number) => {
        const saved = advanceList.find(
          (a: any) =>
            String(a?.advanceInvoiceNumber || '') ===
            String(contractRow?.contractNo || '')
        )

        formData[`contNo-${idx}`] = contractRow?.contractNo || ''
        formData[`date-${idx}`] = formatDate(contractRow?.contractDate, 'dot')
        formData[`accountNo-${idx}`] =
          saved?.accountNumber || contractRow?.accountNo || ''
        formData[`avansReceiverCountryId-${idx}`] =
          saved?.country != null ? String(saved.country) : contractRow?.countryCode != null ? String(contractRow.countryCode) : undefined
        formData[`avansReceiver-${idx}`] = saved?.beneficiaryName || contractRow?.bank || ''
        formData[`avansTransferredAmount-${idx}`] = saved?.advanceAmount || ''
        formData[`avansCurrencyType-${idx}`] = saved?.ccy || ''
        formData[`avansExchange-${idx}`] = ''
      })

      return {
        type: 'Avans',
        iban: data?.CUSTACC ?? null,
        pinCode: pin,
        summary: {
          pinCode: api?.pinCode,
          taxId: api?.taxId,
          name: api?.name,
        },
        contracts: groupedContracts,
        details: api?.details || [],
        gbList: api?.gbList || [],
        form: formData,
      }
    } catch (e) {
      console.error('Avans hydrate failed', pin, e)
      return null
    }
  }

  const hydrateRepeatAkt = async (data: any) => {
    const actList = data?.act || []
    if (!actList.length) return null

    return {
      type: 'AKT',
      iban: data?.CUSTACC ?? null,
      taxId: getCurrentCompany()?.organizationCode ,
      pages: actList.map((row: any, idx: number) => ({
        key: `akt-${idx + 1}`,
        form: {
          actDocDate: formatDate(row?.actDocDate, 'dash'),
          noActDocNumber: String(row?.noActDocNumber) === 'true',
          actDocNumber:
            String(row?.noActDocNumber) === 'true'
              ? undefined
              : row?.actDocNumber ?? '',
          actDocCost: row?.actDocCost ?? '',
          actTransCost: row?.actTransCost ?? '',
          currencyType: row?.ccyCode ?? '',
          actExchange: '',
          actSender: row?.actSender ?? '',
          actServiceProvider: String(row?.actServiceProvider) === 'true',
          actServiceProviderName:
            String(row?.actServiceProvider) === 'true'
              ? row?.actServiceProviderName ?? ''
              : '',
          countryId: row?.country != null ? String(row.country) : undefined,
          goodServiceInfo: row?.goodServiceInfo ?? '',
          note: row?.note ?? '',
        },
      })),
    }
  }

  const buildDgkPayload = () => {
    if (!dgkData?.type) {
      return {
        advance: [],
        ygb: [],
        act: [],
      }
    }

    if (dgkData.type === 'Avans' || dgkData.type === 'AVANS') {
      const formData = dgkData.form || {}
      const contracts = dgkData.contracts || []
      const result: any[] = []

      const indexes = Object.keys(formData)
        .filter((key) => key.startsWith('avansTransferredAmount-'))
        .map((key) => Number(key.split('-')[1]))
        .filter((idx) => !Number.isNaN(idx))
        .sort((a, b) => a - b)

      indexes.forEach((i) => {
        const contractRow = contracts?.[i] || {}
        const contractNo = formData[`contNo-${i}`]
        const contractDate = formData[`date-${i}`]
        const accountNo = formData[`accountNo-${i}`]
        const countryId = formData[`avansReceiverCountryId-${i}`]
        const beneficiaryName = formData[`avansReceiver-${i}`]
        const advanceAmount = formData[`avansTransferredAmount-${i}`]
        const ccy = formData[`avansCurrencyType-${i}`]

        if (!advanceAmount || !ccy || !beneficiaryName || !countryId) return

        result.push({
          pin: dgkData?.pinCode ?? null,
          taxNumber: dgkData?.summary?.taxId ?? null,
          customerFullName: dgkData?.summary?.name ?? null,
          advanceInvoiceNumber: contractNo ?? contractRow?.contractNo ?? null,
          advanceDate: formatDate(contractDate ?? contractRow?.contractDate, 'dot'),
          accountNumber: form.getFieldValue('CUSTACC') || null,
          bankTaxNumber: '9900001901',
          bankUserNumber: '505668',
          country: countryId ?? null,
          beneficiaryName: beneficiaryName ?? null,
          advanceAmount: advanceAmount ?? null,
          ccy: ccy ?? fromBranch?.CCY_NAME ?? null,
          note: "BANK RESPUBLİKA AÇIQ SƏHMDAR CƏMİYYƏTİ 505668 MÜŞTƏRİ XİDMƏTİ DEPARTAMENTİ",
          transactionDate: moment().format("DD.MM.YYYY"),
          PayAcceptance: false,
          PaymentTypeId: 2,

        })
      })

      return {
        advance: result,
        ygb: [],
        act: [],
      }
    }

    if (dgkData.type === 'YGB') {
      const result = (dgkData.pages || []).map((page: any) => {
        const pageForm = page?.form || {}
        const summary = page?.summary || {}
        const countryId = pageForm?.receiverCountryId;
        const selectedContract = (page?.contracts || []).find((c: any) => String(c?.no) === String(pageForm?.contractNo))
        const note = typeof summary?.note === 'string'
          ? summary.note
              .replace(/"/g, '')
              .replace(/(\s+\d+\s+MÜŞTƏRİ\s+XİDMƏTİ\s+DEPARTAMENTİ)\1+/g, '$1')
          : summary?.note ?? null

        return {
          gbNumber: page?.gbNo ?? null,
          taxNumber: summary?.taxId ?? null,
          customerFullname: summary?.name ?? null,
          beneficiaryCountry: summary?.receiverCountry ?? null,
         
          ygbInvoiceCost: summary?.invoiceCost ?? null,
          ygbOperationAmount: summary?.operationAmount ?? null,
         
          ygbRemainderAmount: summary?.egbSum ?? null,
          ygbRemainderCcy: summary?.invoiceCurrency ?? pageForm?.currencyType ?? null,
          bankTaxNumber: '9900001901',
          bankUserNumber: summary?.bankUserNumber ?? '505668',
          ygbPincode: selectedContract?.pincode ?? selectedContract?.pinCode ?? null,
          ygbDocNameKey: 'CUST_DECLARE',
          ygbDocName: 'Yük Gömrük Bəyannaməsi',
          ygbDocNumber: page?.gbNo ?? null,
          ygbImpDocDate: formatDate(summary?.impDocDate, 'dot'),
          ygbDocCost: summary?.impDocCost ?? summary?.invoiceCost ?? null,
          ygbDeclareTypeKey: summary?.declarationTypeKey ?? null,
          ygbSender: summary?.senderOrExporter ?? null,
          goodServiceInfo: summary?.goodOfServiceInfo ?? null,
          contractNumber: pageForm?.contractNo ?? null,
          ygbDocDate: formatDate(pageForm?.contractDate, 'dot'),
          account: fromBranch?.IBAN ?? null,
          sendercountry: pageForm?.receiverCountryId ?? null,
          beneficiaryName: pageForm?.receiverName ?? null,
          countryCode: countryId ?? null,
          TransactionDate: moment().format("DD.MM.YYYY"),
          ygbAmount: pageForm?.transferredAmount ?? null,
          ccy: pageForm?.currencyType ?? fromBranch?.CCY_NAME ?? null,
          note,
          paymentTypeId: 1,

        }
      })

      return {
        advance: [],
        ygb: result,
        act: [],
      }
    }

    if (dgkData.type === 'AKT') {
      const result = (dgkData.pages || []).map((page: any) => {
        const pageForm = page?.form || {}

        return {
          actDocNameKey: 'SERV_ACT',
          actDocName: 'Xidmətlərin qəbul edilməsini təsdiqləyən akt',
          actDocDate: formatDate(pageForm?.actDocDate, 'dot'),
          noActDocNumber: !!pageForm?.noActDocNumber,
          actDocNumber: pageForm?.noActDocNumber
            ? null
            : pageForm?.actDocNumber ?? null,
          actDocCost: pageForm?.actDocCost ?? null,
          actTransCost: pageForm?.actTransCost ?? null,
          actSender: pageForm?.actSender ?? null,
          actServiceProvider: !!pageForm?.actServiceProvider,
          actServiceProviderName: pageForm?.actServiceProvider
            ? pageForm?.actServiceProviderName ?? null
            : null,
          country: pageForm?.countryName ?? pageForm?.countryId ?? null,
          goodServiceInfo: pageForm?.goodServiceInfo ?? null,
          actNumber: pageForm?.noActDocNumber ? '-' : pageForm?.actDocNumber ?? null,
          ccyCode: pageForm?.currencyType ?? fromBranch?.CCY_NAME ?? null,
          note: pageForm?.note ?? null,
          countryCode: pageForm?.countryId ?? null,
          beneficiaryName: pageForm?.beneficiaryName ?? null,
          taxId: getCurrentCompany()?.organizationCode ,
          BranchCode: fromBranch?.BRANCH_NO ?? null,
          transactionDate: moment().format("DD.MM.YYYY"),
          paymentType: 'ocf',
        }
      })

      return {
        advance: [],
        ygb: [],
        act: result,
      }
    }

    return {
      advance: [],
      ygb: [],
      act: [],
    }
  }
  const getDgkTotalExchangeAmount = () => {
  const value = checkAmountForRequest(dgkData?.total_exchange_amount)
  return isNaN(value) ? 0 : Number(value)
}

const isTransferAmountLessThanDgkTotal = () => {
  const transferAmountValue = checkAmountForRequest(form.getFieldValue('AMOUNT'))
  const dgkTotal = getDgkTotalExchangeAmount()

  if (!paymentConditionValue || !dgkData?.type || dgkTotal <= 0) return false
  if (isNaN(transferAmountValue)) return false

  return Number(transferAmountValue) < Number(dgkTotal)
}

const hasDgkAmountError = isTransferAmountLessThanDgkTotal()
  const transferAmount = checkAmountForRequest(form.getFieldValue('AMOUNT'))
  const toConvert = fromBranch?.CCY_NAME

  const updateParentComponentFormData = () => {
    if (ownProps?.getFormElements) {
      ownProps?.getFormElements({ form })
    }
  }
  useEffect(() => {
    if (cancelPMTDETRef.current !== null) {
      form.setFieldValue("PMTDET", cancelPMTDETRef.current)
      cancelPMTDETRef.current = null
      return
    }
    form.setFieldValue("PMTDET", savedDocuments !== '' && documentsCount !== 0 ?
                     (savedDocuments?.length > 339 ?
                      savedDocuments.substring(0, 339) : savedDocuments)
                      : "")
  }, [savedDocuments])

  const saveDocumentsModal = (dataModal: any) => {
    let tempData = JSON.parse(JSON.stringify(dataModal))
    setModalDataDocuments(tempData)
    }

  const addOrEditPage = ownProps?.addOrEditPage || false

  const updateBicCodes = async (modalVisible: boolean = true) => {
    const typed_code = form.getFieldValue('BENEFBANKBIC') || ''
    const typed_name =
      form.getFieldValue('BENEFBANKNAME')?.toString()?.toLowerCase() || ''

    const data = await getBicCodes(typed_code)

    setBicCodes((old_data) => data)
    setToBranch((old_data) => data[0])
  }

  const updateBicCodesFilter = async () => {
    const typed_code = form.getFieldValue('bikCode') || ''
    const typed_name =
      form.getFieldValue('bikName')?.toString()?.toLowerCase() || ''

    const data = await getBicCodes(typed_code)
    const filter_codes = data?.filter((row) =>
      typed_code && typed_name
        ? row.MAIN_BIC.includes(typed_code) &&
          row.BANK_NAME.toString().toLowerCase().includes(typed_name)
        : typed_code
        ? row.MAIN_BIC.includes(typed_code)
        : typed_name
        ? row.BANK_NAME.toString().toLowerCase().includes(typed_name)
        : row
    )

    setBicCodes((old_data) => filter_codes)
    if (filter_codes?.length > 0) setToBranch((old_data) => filter_codes[0])
  }

  const selectCondition = (e: any) => {
  if (!e) return

  setOpenDgkModal(false)
  dispatch(setDgkData(null))
  setDgkModalKey((prev) => prev + 1)

  setPaymentConditionValue(e)
  form.setFieldValue('paymentCondition', e)

  switch (e) {
    case 'PREPAY_GOODS':
      setActiveCondition('Avans')
      break
    case 'POSTPAY_GOODS':
      setActiveCondition('YGB')
      break
    case 'POSTPAY_SERVICE':
      setActiveCondition('AKT')
      break
    case 'PREPAY_SERVICE':
    case 'OTHER':
    default:
      setActiveCondition('')
      break
  }
}

  const updateToBicCodeAndName = (row) => {
    setFormFields((old_data) => ({
      ...old_data,
      BENEFBANKBIC: row.BIC_CODE,
      BENEFBANKNAME: row.BANK_NAME,
      BENEFBANKCORACC: row.CORR,
      BENEFBANKADDR: row.COUNTRY,
    }))

    setFormFields((old_data) => ({
      ...old_data,
      BENEFBANKCODE: row.MAIN_BIC,
    }))

    setCodeModalVisible(false)
    setTimeout(() => {
      calculateCommission({ target: { value: form.getFieldValue('AMOUNT') } })
    }, 100)
  }

  const fetchData = async () => {
    setLoadingAccount(true)
    const data = await getAccounts(getCurrentCompany())

    let temp_data = []

    for (let row of data) {
      if (row.STATUS !== '0') {
        if (row.CCY_NAME.toString().toLowerCase() !== 'rub') {
          continue
        }

        temp_data.push({
          label: row.NICKNAME ? row.NICKNAME : row.IBAN,
          value: row.IBAN,
          extra: `${financial(row.BALANCE)} ${row.CCY_NAME}`,
        })
      }
    }

    setAllAccounts(data.filter((row) => row.STATUS !== '0'))
    setFromSelectOptions((old_data) => temp_data)

    if (location?.state?.trnData) {
      fillCurrentForm(form, location.state.trnData)
    }
    setLoadingAccount(false)
  }

  const loadData = async () => {
    console.log('loadData')
    resetDgkState();
    setLoadingAccount(true)
    setLoadingData(true)
    const data = await getAccounts(getCurrentCompany())
    let temp_data = []
    for (let row of data) {
      if (row.STATUS !== '0') {
        if (row.CCY_NAME.toString().toLowerCase() !== 'rub') {
          continue
        }
        temp_data.push({
          label: row.NICKNAME ? row.NICKNAME : row.IBAN,
          value: row.IBAN,
          extra: `${financial(row.BALANCE)} ${row.CCY_NAME}`,
        })
      }
    }
    setAllAccounts(data.filter((row) => row.STATUS !== '0'))
    setFromSelectOptions((old_data) => temp_data)
    setLoadingAccount(false)

    const pdf = await getSavedDocuments(location.state?.data['ibankRef'])
    setFileList(pdf.data?.fileDetailsList)
    if (location.state?.edit) {
      setEdit(true)
    } else {
      setEdit(false)
    }
    setDocumentsCount(location.state.data['transferDocs']?.length)
    if (location.state.data['transferDocs']?.length > 0) {
      let i = 0
      let documentArr: any = {}
      location.state?.data['transferDocs']?.map((row) => {
        console.log(row.docNumAbsent + ' ' + typeof row.docNumAbsent)
        documentArr = {
          key: i,
          docId: row.docId,
          docName: row.docName,
          docNameLabel: itemsRub.find((r) => r.value === row.docName)?.label,
          docNumAbsent: row.docNumAbsent.toString() === 'true' ? true : false,
          docNum: row.docNum,
          docDate: moment(row.docDate).format('YYYY-MM-DD'),
          docNote: row.docNote,
          isUsed: true,
        }
        documentsModalData[i] = documentArr
        createData[i] = documentArr
        i++
      })
    }
    form.setFieldsValue({
      transferDocs: location.state?.data['transferDocs'],
      })
    setTableData(location.state?.data)
    if (location.state?.edit) setIbankRef(location.state?.data['ibankRef'])
    setPdfCount(location.state?.data['attachedPDF'])

    const value = location.state?.data['CUSTACC']
    const findAccount = data?.find(
      (row) => row.IBAN == value && row.STATUS !== '0'
    )
    if (findAccount !== undefined) {
      form.setFieldsValue({
        CUSTACC: location.state?.data['CUSTACC'],
      })
      setFromBranch(findAccount)
    }
    if (
      (form.getFieldValue('PMTCUSTID') === '' ||
        form.getFieldValue('PMTCUSTID') === undefined) &&
      location.state?.edit === undefined
    ) {
      updateDocumentNumber()
    } else if (location.state?.edit) {
      form.setFieldsValue({
        PMTCUSTID: location.state?.data['PMTCUSTID'],
      })
    }

    form.setFieldsValue({
      BENEFNAME: location.state?.data['COUNTERNAME'].replace('&quot', "'"),
    })
    form.setFieldsValue({
      BENEFACC: location.state?.data['BENEFACC'],
    })
    form.setFieldsValue({
      BENEFTAXID: location.state?.data['BENEFTAXID'],
    })
    form.setFieldsValue({
      AMOUNT: checkAmountForRequest(location.state?.data['AMOUNT']),
    })

    if (location.state?.data['BENEFKPP'] !== undefined) {
      form.setFieldsValue({
        BENEFKPP: location.state?.data['BENEFKPP'],
      })
      if (location.state?.data['BENEFTAXID'] !== undefined) {
        setKppRules((old_data) => {
          return {
            required: location.state?.data['BENEFTAXID']?.length === 10,
            readOnly: location.state?.data['BENEFTAXID']?.length !== 10,
          }
        })
      }
    }

    form.setFieldsValue({
      OWNBENEFPRACC: location.state?.data['BENEFPRACC'],
    })
    form.setFieldsValue({
      BENEFBANKBIC: location.state?.data['BENEFBANKBIC'],
    })
    form.setFieldsValue({
      BENEFBANKNAME: location.state?.data['BENEFBANKNAME']?.replaceAll(
        '&quot;',
        '"'
      ),
    })
    form.setFieldsValue({
      BENEFBANKCORACC: location.state?.data['BENEFBANKCORACC'],
    })
    form.setFieldsValue({
      BENEFBANKADDR: location.state?.data['BENEFBANKADDR'],
    })
    if (
      location.state?.data['BENEFBANKBIC'] !== undefined &&
      location.state?.data['BENEFBANKBIC'] !== ''
    ) {
      setKppRules((old_data) => {
        return {
          required: false,
          readOnly: true,
        }
      })
    }
    // PMTDET

    {
      const toVal = (v: any) => (v == null || v === 'null' ? '' : String(v).trim());
      const pmtDet = toVal(location.state?.data['PMTDET']);
      const infoToBenef = toVal(location.state?.data['INFOTOBENEF']);
      form.setFieldsValue({
        PMTDET: [pmtDet, infoToBenef].filter(Boolean).join(' ') || '',
      });
    }
    form.setFieldsValue({
      BENEFBANKCODE: location.state?.data['BENEFBANKBIC'],
    })

    if (
      location.state?.data['AMOUNT'] !== undefined &&
      location.state?.data['AMOUNT'] !== ''
    ) {
      let value = checkAmountForRequest(location.state?.data['AMOUNT'])

      if (!isNaN(value)) {
        setCommissionLoading(true)
        getCustomerCommission({
          PAYMENT_TYPE: 'SWIFT_RUB',
          CIF: getCurrentCompany().customerNo,
          CUSTACC: location.state?.data['CUSTACC'],
          AMOUNT: value,
          CUR: location.state?.data['ccyType'],
          BENEFBANKCODE: location.state?.data['BENEFBANKBIC'],
          BENEFACC: location.state?.data['BENEFACC'],
          BENEFTAXID: location.state?.data['BENEFTAXID'],
          PMTDET: location.state?.data['PMTDET']?.toString().toUpperCase(),
        }).then((res) => {
          setCommissionLoading(false)
          form.setFieldsValue({
            COMMAMOUNT: res.COM_AMOUNT ?? '',
          })
          setCommissionAmount((old_value) => res.COM_AMOUNT ?? '')
        })
      }
    }

    // form.setFieldsValue({
    //   INFOTOBENEF: location.state?.data['INFOTOBENEF'],
    // })

    const paymentOption = location.state?.data?.paymentOption || undefined

setPaymentConditionValue(paymentOption)
form.setFieldsValue({
  paymentCondition: paymentOption,
})

const repeatDgkYgb = mapRepeatYgbToDgkState(location.state?.data)
const repeatDgkAdvance = mapRepeatAdvanceToDgkState(location.state?.data)
const repeatDgkAct = mapRepeatActToDgkState(location.state?.data)

if (repeatDgkYgb) {
  dispatch(setDgkData(repeatDgkYgb))
  setActiveCondition('YGB')
} else if (repeatDgkAdvance) {
  dispatch(setDgkData(repeatDgkAdvance))
  setActiveCondition('Avans')
} else if (repeatDgkAct) {
  dispatch(setDgkData(repeatDgkAct))
  setActiveCondition('AKT')
} else {
  dispatch(setDgkData(null))
  switch (paymentOption) {
    case 'PREPAY_GOODS':
      setActiveCondition('Avans')
      break
    case 'POSTPAY_GOODS':
      setActiveCondition('YGB')
      break
    case 'POSTPAY_SERVICE':
      setActiveCondition('AKT')
      break
    default:
      setActiveCondition('')
      break
  }
}

const ygbHydrated = await hydrateRepeatYgb(location.state?.data)
if (ygbHydrated) {
  dispatch(setDgkData(ygbHydrated))
  setActiveCondition('YGB')
}

const aktHydrated = await hydrateRepeatAkt(location.state?.data)
if (aktHydrated) {
  dispatch(setDgkData(aktHydrated))
  setActiveCondition('AKT')
}

const avansHydrated = await hydrateRepeatAvans(location.state?.data)
if (avansHydrated) {
  dispatch(setDgkData(avansHydrated))
  setActiveCondition('Avans')
}

    setLoadingData(false)
  }

  const loadDataTemplate = async (tempData) => {
    setLoadingData(true)
    const docid = documentNumber
    form.resetFields()
    if (tempData?.trnData) {
      fillCurrentFormTemplate(form, tempData?.trnData)
      updateParentComponentFormData()
    }
    if (docid !== '' && docid !== undefined) {
      form.setFieldsValue({
        PMTCUSTID: docid,
      })
      setDocumentNumber((old_value) => docid)
    }
    setDocumentsCount(tempData?.trnData['transferDocs']?.length)
    if (tempData?.trnData['transferDocs']?.length > 0) {
      let i = 0
      let documentArr: any = {}
      tempData?.trnData['transferDocs']?.map((row) => {
        documentArr = {
          key: i,
          docId: row.docId,
          docName: row.docName,
          docNameLabel: itemsRub.find((r) => r.value === row.docName)?.label,
          docNumAbsent: row.docNumAbsent.toString() === 'true' ? true : false,
          docNum: row.docNum,
          docDate: moment(row.docDate).format('YYYY-MM-DD'),
          docNote: row.docNote,
          isUsed: true,
        }
        documentsModalData[i] = documentArr
        createData[i] = documentArr
        i++
      })
      form.setFieldsValue({
        transferDocs: tempData?.trnData.transferDocs,
      })
    }

    const findAccount = allAccounts?.find(
      (row) => row.IBAN == tempData?.trnData.CUSTACC && row.STATUS !== '0'
    )
    if (findAccount !== undefined) {
      form.setFieldsValue({
        CUSTACC: tempData?.trnData.CUSTACC,
      })
      setFromBranch(findAccount)
      if (docid === '' || docid === undefined) {
        updateDocumentNumber()
      }
    }
    if (
      tempData?.trnData.BENEFTAXID !== undefined &&
      tempData?.trnData.BENEFTAXID !== null
    )
      setKppRules((old_data) => {
        return {
          required: tempData?.trnData.BENEFTAXID.length === 10,
          readOnly: tempData?.trnData.BENEFTAXID.length !== 10,
        }
      })
    if (
      tempData?.trnData.AMOUNT !== undefined &&
      tempData?.trnData.AMOUNT !== ''
    ) {
      let value = checkAmountForRequest(tempData?.trnData.AMOUNT)

      if (!isNaN(value)) {
        setCommissionLoading(true)
        getCustomerCommission({
          PAYMENT_TYPE: 'SWIFT_RUB',
          CIF: getCurrentCompany().customerNo,
          CUSTACC: tempData?.trnData.CUSTACC,
          AMOUNT: value,
          CUR: findAccount?.CCY_NAME,
          BENEFBANKCODE: '',
          BENEFACC: tempData?.trnData.BENEFACC,
          BENEFTAXID: tempData?.trnData.BENEFTAXID,
          PMTDET: tempData?.trnData.PMTDET?.toString().toUpperCase(),
        }).then((res) => {
          setCommissionLoading(false)
          form.setFieldsValue({
            COMMAMOUNT: res.COM_AMOUNT ?? '',
          })
          setCommissionAmount((old_value) => res.COM_AMOUNT ?? '')
        })
      }
    }
    form.setFieldsValue({
      PMTDET: tempData?.trnData.INFOTOBENEF !== null && tempData?.trnData.INFOTOBENEF !== undefined ? (tempData?.trnData.PMTDET ? tempData?.trnData.PMTDET?.trim() + " " + tempData?.trnData.INFOTOBENEF : tempData?.trnData.INFOTOBENEF) : tempData?.trnData.PMTDET?.trim(),
    })
    setSaveDocuments(tempData?.trnData.INFOTOBENEF !== null && tempData?.trnData.INFOTOBENEF !== undefined ? (tempData?.trnData.PMTDET !== undefined && tempData?.trnData.PMTDET !== null ? tempData?.trnData.PMTDET?.trim() + " " + tempData?.trnData.INFOTOBENEF : tempData?.trnData.INFOTOBENEF) : tempData?.trnData.PMTDET?.trim())

    setLoadingData(false)
  }

  const loadDataTemplate2 = async (tempData) => {
    setLoadingData(true)
    setLoadingAccount(true)
    if (tempData?.trnData) {
      await fillCurrentForm(form, tempData?.trnData)
    }
    const data = await getAccounts(getCurrentCompany())
    let temp_data = []
    for (let row of data) {
      if (row.STATUS !== '0') {
        if (row.CCY_NAME.toString().toLowerCase() !== 'rub') {
          continue
        }
        temp_data.push({
          label: row.NICKNAME ? row.NICKNAME : row.IBAN,
          value: row.IBAN,
          extra: `${financial(row.BALANCE)} ${row.CCY_NAME}`,
        })
      }
    }
    setDocumentsCount(tempData?.trnData['transferDocs']?.length)
    if (tempData?.trnData['transferDocs']?.length > 0) {
      let i = 0
      let documentArr: any = {}
      tempData?.trnData['transferDocs']?.map((row) => {
        documentArr = {
          key: i,
          docId: row.docId,
          docName: row.docName,
          docNameLabel: itemsRub.find((r) => r.value === row.docName)?.label,
          docNumAbsent: row.docNumAbsent.toString() === 'true' ? true : false,
          docNum: row.docNum,
          docDate: moment(row.docDate).format('YYYY-MM-DD'),
          docNote: row.docNote,
          isUsed: true,
        }
        documentsModalData[i] = documentArr
        createData[i] = documentArr
        i++
      })
      setcreateData(createData)
      form.setFieldsValue({
        transferDocs: createData,
      })
      setModalDataDocuments(documentsModalData)
    }
    setAllAccounts(data.filter((row) => row.STATUS !== '0'))
    setFromSelectOptions((old_data) => temp_data)
    setLoadingAccount(false)

    const findAccount = data?.find(
      (row) => row.IBAN == tempData?.trnData.CUSTACC && row.STATUS !== '0'
    )
    if (findAccount !== undefined) {
      form.setFieldsValue({
        CUSTACC: tempData?.trnData.CUSTACC,
      })
      setFromBranch(findAccount)
      if (
        form.getFieldValue('PMTCUSTID') === '' ||
        form.getFieldValue('PMTCUSTID') === undefined
      ) {
        await updateDocumentNumber()
      }
    }

    form.setFieldsValue({
      PMTDET: tempData?.trnData.INFOTOBENEF !== null && tempData?.trnData.INFOTOBENEF !== undefined ? (tempData?.trnData.PMTDET ? tempData?.trnData.PMTDET?.trim() + " " + tempData?.trnData.INFOTOBENEF : tempData?.trnData.INFOTOBENEF) : tempData?.trnData.PMTDET?.trim(),
    })
    setSaveDocuments(tempData?.trnData.INFOTOBENEF !== null && tempData?.trnData.INFOTOBENEF !== undefined ? (tempData?.trnData.PMTDET !== undefined && tempData?.trnData.PMTDET !== null ? tempData?.trnData.PMTDET?.trim() + " " + tempData?.trnData.INFOTOBENEF : tempData?.trnData.INFOTOBENEF) : tempData?.trnData.PMTDET?.trim())

    // form.setFieldsValue({
    //   INFOTOBENEF: tempData?.trnData.INFOTOBENEF,
    // })
    if (
      tempData?.trnData.BENEFTAXID !== undefined &&
      tempData?.trnData.BENEFTAXID !== null
    )
      setKppRules((old_data) => {
        return {
          required: tempData?.trnData.BENEFTAXID.length === 10,
          readOnly: tempData?.trnData.BENEFTAXID.length !== 10,
        }
      })
    if (
      tempData?.trnData.AMOUNT !== undefined &&
      tempData?.trnData.AMOUNT !== ''
    ) {
      let value = checkAmountForRequest(tempData?.trnData.AMOUNT)
      form.setFieldsValue({
        AMOUNT: value,
      })

      if (!isNaN(value)) {
        setCommissionLoading(true)
        const res = await getCustomerCommission({
          PAYMENT_TYPE: 'SWIFT_RUB',
          CIF: getCurrentCompany().customerNo,
          CUSTACC: tempData?.trnData.CUSTACC,
          AMOUNT: value,
          CUR: findAccount?.CCY_NAME,
          BENEFBANKCODE: '',
          BENEFACC: tempData?.trnData.BENEFACC,
          BENEFTAXID: tempData?.trnData.BENEFTAXID,
          PMTDET: tempData?.trnData.PMTDET?.toString().toUpperCase(),
        })

        if (res !== undefined) {
          setCommissionLoading(false)
          form.setFieldsValue({
            COMMAMOUNT: res.COM_AMOUNT ?? '',
          })
          setCommissionAmount((old_value) => res.COM_AMOUNT ?? '')
        }
      }
    }

    const repeatDgkYgb = mapRepeatYgbToDgkState(tempData?.trnData)
    const repeatDgkAdvance = mapRepeatAdvanceToDgkState(tempData?.trnData)
    const repeatDgkAct = mapRepeatActToDgkState(tempData?.trnData)

    if (repeatDgkYgb) {
      dispatch(setDgkData(repeatDgkYgb))
      setActiveCondition('YGB')
      setPaymentConditionValue('POSTPAY_GOODS')
      form.setFieldsValue({
        paymentCondition: 'POSTPAY_GOODS',
      })
    } else if (repeatDgkAdvance) {
      dispatch(setDgkData(repeatDgkAdvance))
      setActiveCondition('Avans')
      setPaymentConditionValue('PREPAY_GOODS')
      form.setFieldsValue({
        paymentCondition: 'PREPAY_GOODS',
      })
    } else if (repeatDgkAct) {
      dispatch(setDgkData(repeatDgkAct))
      setActiveCondition('AKT')
      setPaymentConditionValue('POSTPAY_SERVICE')
      form.setFieldsValue({
        paymentCondition: 'POSTPAY_SERVICE',
      })
    }

    const ygbHydrated = await hydrateRepeatYgb(tempData?.trnData)
    if (ygbHydrated) {
      dispatch(setDgkData(ygbHydrated))
      form.setFieldsValue({ paymentCondition: 'POSTPAY_GOODS' })
      setPaymentConditionValue('POSTPAY_GOODS')
      setActiveCondition('YGB')
    }

    const aktHydrated = await hydrateRepeatAkt(tempData?.trnData)
    if (aktHydrated) {
      dispatch(setDgkData(aktHydrated))
      form.setFieldsValue({ paymentCondition: 'POSTPAY_SERVICE' })
      setPaymentConditionValue('POSTPAY_SERVICE')
      setActiveCondition('AKT')
    }

    const avansHydrated = await hydrateRepeatAvans(tempData?.trnData)
    if (avansHydrated) {
      dispatch(setDgkData(avansHydrated))
      form.setFieldsValue({ paymentCondition: 'PREPAY_GOODS' })
      setPaymentConditionValue('PREPAY_GOODS')
      setActiveCondition('Avans')
    }

    updateParentComponentFormData()
    setLoadingData(false)
  }
    useEffect(() => {
    return () => {
      dispatch(setDgkData(null))
    }
  }, [dispatch])
  useEffect(() => {
    resetDgkState()

    if (location.state?.data !== undefined) loadData()
    else if (location.state?.trnData) loadDataTemplate2(location.state)
    else fetchData()
  }, [location.state])
  const resetDgkState = () => {
    dispatch(setDgkData(null))
    setActiveCondition('')
    setPaymentConditionValue(undefined)
    form.setFieldsValue({
      paymentCondition: undefined,
    })
  }
  
  const updateDocumentNumber = async () => {
    const document_number = await getRubDocumentNumber(getCurrentCompany())
    form.setFieldsValue({
      PMTCUSTID: document_number,
    })

    setDocumentNumber((old_value) => document_number)
  }

  const getSelectedFromBranch = (value: any) => {
    const findAccount = allAccounts?.find((row) => row.IBAN == value)
    setFromBranch(findAccount)

    if (!form.getFieldValue('PMTCUSTID') && value) {
      updateDocumentNumber()
    }
  }
  const isDgkCompleted = () => {
  if (!paymentConditionValue) return false

  if (
    paymentConditionValue === 'PREPAY_SERVICE' ||
    paymentConditionValue === 'OTHER'
  ) {
    return true
  }

  if (!dgkData?.type) return false

  if (dgkData.type === 'YGB') {
    return (
      Array.isArray(dgkData.pages) &&
      dgkData.pages.length > 0 &&
      dgkData.pages.every((page: any) => {
        const pageForm = page?.form || {}
        return (
          pageForm.gbNo &&
          pageForm.contractNo &&
          pageForm.contractDate &&
          pageForm.receiverCountryId &&
          pageForm.receiverName &&
          pageForm.transferredAmount &&
          pageForm.currencyType
        )
      })
    )
  }

  if (dgkData.type === 'AKT') {
    return (
      Array.isArray(dgkData.pages) &&
      dgkData.pages.length > 0 &&
      dgkData.pages.every((page: any) => {
        const pageForm = page?.form || {}
        const providerExists = !!pageForm.actServiceProvider
        return (
          pageForm.actDocDate &&
          (pageForm.noActDocNumber || pageForm.actDocNumber) &&
          pageForm.actDocCost &&
          pageForm.actTransCost &&
          pageForm.currencyType &&
          (providerExists ? pageForm.actServiceProviderName : pageForm.actSender) &&
          pageForm.countryId &&
          pageForm.goodServiceInfo
        )
      })
    )
  }

  if (dgkData.type === 'Avans' || dgkData.type === 'AVANS') {
    const contracts = dgkData.contracts || []
    const formData = dgkData.form || {}

    if (!contracts.length) return false

    return contracts.every((_: any, i: number) => {
      return (
        formData[`contNo-${i}`] &&
        formData[`date-${i}`] &&
        formData[`accountNo-${i}`] &&
        formData[`avansReceiverCountryId-${i}`] &&
        formData[`avansReceiver-${i}`] &&
        formData[`avansTransferredAmount-${i}`] &&
        formData[`avansCurrencyType-${i}`]
      )
    })
  }

  return false
}
  useEffect(() => {
    if (
      ibanNumber.iban &&
      allAccounts &&
      ibanNumber.ccy_name?.toString()?.toLowerCase() === 'rub'
    ) {
      const findAccount = allAccounts?.find(
        (row) => row.IBAN == ibanNumber.iban
      )
      setFromBranch(findAccount)

      if (!form.getFieldValue('PMTCUSTID') && ibanNumber.iban) {
        updateDocumentNumber()
      }

      setIbanNumber({ iban: undefined, ccy_name: undefined })
    }
  }, [ibanNumber, allAccounts])

useEffect(() => {
  setPdfCount(form.getFieldValue('pdf_files')?.length)
},[form.getFieldValue('pdf_files')])

  const newTransferFunc = async (RequestType: string, retry: boolean = false) => {
    let amount = checkAmountForRequest(form.getFieldValue('AMOUNT'))
    let comission = checkAmountForRequest(form.getFieldValue('COMMAMOUNT'))
    let pdf_files = form.getFieldValue('pdf_files') ?? []
    if (pdfCount === 0) {
      setPdfCount(pdf_files.length)
    }
    if (ibankRef !== '') {
      await deleteFileById(ibankRef)
      await new Promise((res) => setTimeout(res, 1000))
    }
    const creatDocData: any = []

    createData?.map((row: any, index: any) => {

      creatDocData.push({
        "docId": index+1,
        "docName": row?.docName,
        "docNumAbsent": row?.docNumAbsent,
        "docNum": row?.docNum,
        "docDate": row?.docDate,
        "docNote": row?.docNote
      })
    })

    if (!retry && retryRequest === null) {
      const dgkPayload = buildDgkPayload() 
      const req = {
        trnRequestType: RequestType,
        ccy: 1,
        ccyType: fromBranch?.CCY_NAME,
        PMTTYPECODE: 'SWIFT_RUB',
        PMTCUSTID: form.getFieldValue('PMTCUSTID'),
        CUSTCIF: getCurrentCompany().customerNo,
        CUSTACC: fromBranch?.IBAN,
        AMOUNT: amount,
        BENEFNAME: form.getFieldValue('BENEFNAME').toString().toUpperCase(),
        BENEFTAXID: form.getFieldValue('BENEFTAXID'),
        BENEFKPP: form.getFieldValue('BENEFKPP'),
        BENEFPRACC: form.getFieldValue('OWNBENEFPRACC'),
        BENEFBANKBIC: form.getFieldValue('BENEFBANKBIC'),
        BENEFBANKCORACC: form.getFieldValue('BENEFBANKCORACC'),
        BENEFACC: form.getFieldValue('BENEFACC')?.toUpperCase(),
        BENEFBANKNAME: form.getFieldValue('BENEFBANKNAME'),
        BENEFBANKADDR: form.getFieldValue('BENEFBANKADDR'),
        PMTDET: form.getFieldValue('PMTDET')?.toString().toUpperCase(),
        // INFOTOBENEF:
        //   form.getFieldValue('INFOTOBENEF') !== undefined &&
      //     form.getFieldValue('INFOTOBENEF') !== null
        //     ? form.getFieldValue('INFOTOBENEF')?.toString().toUpperCase()
        //     : '',
        NOTE: form.getFieldValue('NOTE'),
        CUSTACCFORCOM: fromBranch?.IBAN,
        COMMAMOUNT: comission,
        ibankRef: ibankRef,
        attachedPDF: pdfCount,
        transferDocs: creatDocData,
        paymentOption:form.getFieldValue("paymentCondition"),
         paymentDurationCondition:
          paymentConditionValue === "PREPAY_SERVICE" ? "4" :
          paymentConditionValue === "OTHER" ? null :
          paymentConditionValue === "POSTPAY_GOODS" ? "1" :
          paymentConditionValue === "POSTPAY_SERVICE" ? "2" :
          paymentConditionValue === "PREPAY_GOODS" ? "3" :
          undefined,
        ...dgkPayload,
      }
      setRetryRequest(req)
      const data = newMoneyTransferSwiftRub(req)
      resetForm(form)
      resetFormFields()
      return data
    } else {
      const updatedRetryRequest = {
        ...retryRequest,
        trnRequestType: RequestType,
        ...buildDgkPayload(),
      }

      setRetryRequest(updatedRetryRequest)
      const data = newMoneyTransferSwiftRub(updatedRetryRequest)
      resetForm(form)
      resetFormFields()
      return data
    }
  }

  const onCloseSuccessModal = () => {
  dispatch(setDgkData(null))
  setActiveCondition('')
  setPaymentConditionValue(undefined)

  resetForm(form)
  resetFormFields()
  setDocumentsCount(0)
  setCommissionAmount('')
  setFormFields((old_data) => ({
    ...old_data,
    BENEFBANKCODE: '',
    BENEFBANKNAME: '',
    BENEFBANKADDR: '',
  }))
  setCommissionAmount('')
  form.setFieldsValue({
    BICINPUTTYPE: 'SWIFT',
    PMTDET: '',
    paymentCondition: undefined,
  })
  saveDocumentsModal(dataDocumentModal)
}

  const submitHandler = async (args: any) => {
    // Server-of-record guard: the "Next" button's `disabled` prop is only a UI
    // hint and can be stripped via devtools. Re-enforce the same rules here so a
    // tampered/forced submit with an incomplete DGK (customs) selection — or a
    // transfer amount below the DGK total — is still rejected before proceeding.
    if (!isDgkCompleted()) {
      message.warning(t('dgk.fillDgkWarning'))
      return
    }
    if (isTransferAmountLessThanDgkTotal()) {
      message.warning(t('dgk.amountLessThanDgkWarning'))
      return
    }

    console.log('Before commission')
    const result = await calculateCommission(args.AMOUNT)
    console.log('After commission, result:', result)
    let amount = financial(form.getFieldValue('AMOUNT'))
    let comission = financial(form.getFieldValue('COMMAMOUNT'))

    let pdf_files = form.getFieldValue('pdf_files') ?? []
    modalDataInitial.pdfFiles = []

    if (pdf_files.length > 0) {
      for (let file of pdf_files) {
        modalDataInitial.pdfFiles.push({
          label: file.name,
          file: file,
        })
      }
    }

    setModalData((old_data) => ({
      ...modalDataInitial,
      groups: [
        {
          title: false,
          tableHasBorderBottom: true,
          data: [
            {
              label: t('transfers.sender'),
              value: getCurrentCompany().name,
            },
            {
              label: t('salary.documentNo'),
              value: `${args.PMTCUSTID}`,
            },
            {
              label: t('transfers.fromAccount'),
              value: `${fromBranch?.IBAN} ${fromBranch?.CCY_NAME}`,
            },
          ],
        },
        {
          title: t('requisites.beneficiary'),
          tableHasBorderBottom: true,
          tableHasMarginBottom: true,
          data: [
            {
              label: t('requisites.name'),
              value: `${args.BENEFNAME.toString().toUpperCase()}`,
            },
            {
              label: t('transfers.accountNumber'),
              value: `${args.BENEFACC?.toUpperCase()}`,
            },
            {
              label: t('requisites.taxID'),
              value: args.BENEFTAXID ?? '',
            },
            {
              label: t('newTransfer.kpp'),
              value: `${args.BENEFKPP ?? ''}`,
            },
            {
              label: t('newTransfer.privateAccount'),
              value: `${args.OWNBENEFPRACC ?? ''}`,
            },
          ],
        },
        {
          title: t('requisites.beneficiaryBank'),
          tableHasBorderBottom: false,
          tableHasMarginBottom: true,
          data: [
            {
              label: t('newTransfer.bik'),
              value: `${args.BENEFBANKBIC}`,
            },
            {
              label: t('requisites.name'),
              value: `${args.BENEFBANKNAME}`,
            },
            {
              label: t('newTransfer.correspondentAccount'),
              value: `${args.BENEFBANKCORACC}`,
            },
            {
              label: t('newTransfer.addressCity'),
              value: `${args.BENEFBANKADDR}`,
            },
          ],
        },
        {
          title: false,
          data: [
            {
              label: t('common.amount'),
              value: `${amount} RUB`,
            },
            {
              label: t('home.commission'),
              value: `${comission} RUB`,
            },
            {
              label: t('dgk.payment_terms'),
              value:
                paymentOptions.find(
                  (item) => item.value === form.getFieldValue('paymentCondition')
                )?.label || '',
            },
            {
              label: t('accountStatement.paymentDetails'),
              value:
                args.PMTDET !== undefined && args.PMTDET !== null
                  ? args.PMTDET.toString().toUpperCase()
                  : '',
            },
            // {
            //   label: t('transfers.infoForBeneficiary'),
            //   value:
            //     args.INFOTOBENEF !== undefined && args.INFOTOBENEF !== null
            //       ? args.INFOTOBENEF.toString().toUpperCase()
            //       : '',
            // },
            args.NOTE !== undefined
              ? {
                  label: t('newTransfer.note'),
                  value: args.NOTE ?? '',
                }
              : undefined,
          ],
        },
      ],
    }))


    setNextModalVisible((old_value) => true)
  }

  const getFileList = (info: any) => {
    form.setFieldsValue({
      pdf_files: info.fileList,
    })
  }

  const calculateCommission = async (e: any) => {
    let value
    if (e?.target !== undefined) {
      value = checkAmountForRequest(e.target.value)
    } else {
      value = checkAmountForRequest(e)
    }

    if (!isNaN(value)) {
      setCommissionLoading(true)

        try {
          const res = await getCustomerCommission({
            PAYMENT_TYPE: 'SWIFT_RUB',
            CIF: getCurrentCompany().customerNo,
            CUSTACC: fromBranch?.IBAN,
            AMOUNT: value,
            CUR: fromBranch?.CCY_NAME,
            BENEFBANKCODE: form.getFieldValue('BENEFBANKCODE'),
            BENEFACC: form.getFieldValue('BENEFACC')?.toUpperCase(),
            BENEFTAXID: form.getFieldValue('BENEFTAXID'),
            PMTDET: form.getFieldValue('PMTDET')?.toString().toUpperCase(),
          })

          setCommissionLoading(false)

      form.setFieldsValue({
        COMMAMOUNT: res.COM_AMOUNT ?? "",
      });

        setCommissionAmount(res.COM_AMOUNT ?? '')
        return res.COM_AMOUNT ?? ''
      } catch (err) {
        setCommissionLoading(false)
        console.error('Commission error:', err)
        return ''
      }
    } else {
      setCommissionLoading(false)

      form.setFieldsValue({
        COMMAMOUNT: '',
      })

      setCommissionAmount('')
      return ''
    }
  }

  const openSaveAsTemplateModal = () => {
    setSaveAsTemplatePopupVisible((old_data) => false)

    form
      .validateFields()
      .then((res) => {
        setSaveAsTemplatePopupVisible((old_data) => true)
        const creatDocData: any = []

        createData?.map((row: any, index: any) => {
          creatDocData.push({
            docId: index + 1,
            docName: row?.docName,
            docNumAbsent: row?.docNumAbsent,
            docNum: row?.docNum,
            docDate: row?.docDate,
            docNote: row?.docNote,
          })
        })
        setDocumentsData(creatDocData)
      })
      .catch((err_input_list) => {})
  }

  const updateDocumentNumberAndCommission = (data) => {
    loadDataTemplate(data)
  }

  const resetFormFields = () => {
    setFormFields((old_data) => {})
  }

  const updateKpp = (e) => {
    let value = e?.target?.value
    form.resetFields(['BENEFKPP'])

    setKppRules((old_data) => {
      return {
        required: value?.length === 10,
        readOnly: value?.length !== 10,
      }
    })
    setTimeout(() => {
      calculateCommission({ target: { value: form.getFieldValue('AMOUNT') } })
    }, 100)
  }

  const updateKppOnChange = (e) => {
    let value = e
    form.resetFields(['BENEFKPP'])

    setKppRules((old_data) => {
      return {
        required: value?.length === 10,
        readOnly: value?.length !== 10,
      }
    })
    setTimeout(() => {
      calculateCommission({ target: { value: form.getFieldValue('AMOUNT') } })
    }, 100)
  }

  const changeAccount = (e) => {
    let value = e?.target?.value

    if (value?.length > 0 && form.getFieldValue('AMOUNT') !== '')
      setTimeout(() => {
        calculateCommission({ target: { value: form.getFieldValue('AMOUNT') } })
      }, 100)
  }

  const removeFile = (index: any) => {
    const myNewFiles = [...fileList]
    myNewFiles.splice(index, 1)
    setFileList(myNewFiles)
  }

  return (
    <>
      <div className="text-container" style={{
        marginLeft:"65px"
      }}>
        <p style={{ color: '#7B61FF' }}>
          <p style={{ fontWeight: '550', fontSize: 17 }}>
            {t('transfers.attentionCustomer')}
          </p>
          <ul>
            <li>{t('transfers.customerAttentionTextFirst')}</li>
            <li>{t('transfers.customerAttentionTextSecond')}</li>
            <li>{t('transfers.customerAttentionTextThird')}</li>
            <li>{t('transfers.customerAttentionTextFourth')}</li>
          </ul>
        </p>
      </div>
      <Row></Row>
      <Row>
        <Col flex={'700px'} className="own-account">
          <Card bordered={false}>
            <Row justify="start" className="own-account__form">
              <Form
                labelCol={{ flex: '190px' }}
                wrapperCol={{ flex: 1 }}
                className="full"
                onSubmit={(e) => e.preventDefault(e)}
                onFinish={submitHandler}
                id={'form'}
                form={form}
                autoComplete="off"
                onValuesChange={updateParentComponentFormData}
                scrollToFirstError={{
                  behavior: 'smooth',
                  block: 'center',
                  inline: 'center',
                }}
              >
                {!addOrEditPage && (
                  <div className="flex ">
                    <InputField
                      labelItem={t('salary.documentNo')}
                      placeholder={t('salary.automatically')}
                      name={'PMTCUSTID'}
                      required={true}
                      form={form}
                      value={documentNumber}
                      message={true}
                      allowLatinNumber={true}
                    />

                    <Button
                      size={'large'}
                      icon={<SaveIco />}
                      className="blue-button transfer__button flex align_center justify_center create_tr_template_btn"
                      onClick={(e) => setTemplatePopupVisible(true)}
                    >
                      {OWNACCOUNT.PATTERN}
                    </Button>
                  </div>
                )}

                <SelectField
                  labelItem={t('transfers.fromAccount')}
                  placeholder={t('accountStatement.chooseAccount')}
                  options={fromSelectOptions}
                  name={'CUSTACC'}
                  onChange={getSelectedFromBranch}
                  required={true}
                  form={form}
                  account={true}
                  notFoundContent={
                    !loadingAccount
                      ? t('newTransfer.noAccountCorrespondingCurrency')
                      : undefined
                  }
                  defaultValue={
                    ibanNumber.ccy_name?.toString()?.toLowerCase() === 'rub'
                      ? ibanNumber.iban
                      : undefined
                  }
                />

                <Divider
                  plain
                  orientation="left"
                  className={'tab_divider_left'}
                >
                  Alan
                </Divider>

                <InputField
                  labelItem={t('requisites.name')}
                  placeholder={t('newTransfer.nameBeneficiary')}
                  required={true}
                  name={'BENEFNAME'}
                  maxLength={90}
                  showCount={true}
                  allowRusUpper={true}
                  form={form}
                  readOnly={!fromBranch?.ACCOUNT_NO}
                  className={'isDisabled is_upper_case'}
                  upper={true}
                />

                <InputField
                  labelItem={t('deposit.accountNumber')}
                  placeholder=""
                  className="is_upper_case isDisabled"
                  name={'BENEFACC'}
                  required={true}
                  isNumeric={true}
                  onlyNumber={true}
                  maxLength={20}
                  form={form}
                  readOnly={!fromBranch?.ACCOUNT_NO}
                  onBlur={changeAccount}
                  account={true}
                />

                <div className={'flex justify_between'}>
                  <InputField
                    labelItem={t('requisites.taxID')}
                    placeholder=""
                    className={
                      'amount_and_commission_col not-required no_flex commission_left commission_left2 rub_amount_200 isDisabled'
                    }
                    isNumeric={true}
                    onlyNumber={true}
                    maxLength={12}
                    name={'BENEFTAXID'}
                    form={form}
                    readOnly={!fromBranch?.ACCOUNT_NO}
                    onKeyUp={updateKpp}
                  />

                  <InputField
                    labelItem={t('newTransfer.kpp')}
                    placeholder=""
                    className="rub_amount_200  not-required commission_right"
                    name={'BENEFKPP'}
                    maxLength={9}
                    onlyNumber={true}
                    form={form}
                    readOnly={!fromBranch?.ACCOUNT_NO || kppRules.readOnly}
                    required={kppRules.required}
                  />
                </div>

                <InputField
                  labelItem={t('newTransfer.privateAccount')}
                  placeholder=""
                  required={false}
                  onlyNumber={true}
                  maxLength={11}
                  className={'not-required isDisabled'}
                  name={'OWNBENEFPRACC'}
                  form={form}
                  readOnly={!fromBranch?.ACCOUNT_NO}
                />

                <div
                  className="text-container"
                  style={{ marginLeft: '65px', marginBottom: '20px' }}
                >
                  <p style={{ color: '#7B61FF', textAlign: 'start' }}>
                    <p>{t('transfers.attentionForCustomer')}</p>
                  </p>
                </div>

                <Divider
                  plain
                  orientation="left"
                  className={'tab_divider_left'}
                >
                  {t('newTransfer.beneficiaryBank')}
                </Divider>

                <div className="flex">
                  <InputField
                    labelItem={t('newTransfer.bik')}
                    placeholder={t('newTransfer.atLeast2Char')}
                    allowClear={false}
                    className="not_show_required_props isReadOnly"
                    name={'BENEFBANKBIC'}
                    required={true}
                    isNumeric={true}
                    onlyNumber={true}
                    form={form}
                    readOnly={!fromBranch?.ACCOUNT_NO}
                    value={formFields?.BENEFBANKBIC}
                    onKeyUp={() => {
                      updateBicCodes(false)
                    }}
                    autoComplete={true}
                    options={bicCodes}
                    filterRowClick={updateToBicCodeAndName}
                  />
                  <Col flex="40px" style={{ marginLeft: 10 }}>
                    <Button
                      size={'large'}
                      icon={<SearchIco />}
                      className="blue-button transfer__button flex align_center justify_center search_btn"
                      onClick={() => setCodeModalVisible(true)}
                      disabled={!fromBranch?.ACCOUNT_NO}
                    ></Button>
                  </Col>

                  <Modal
                    title={t('newTransfer.bicCodes')}
                    closeIcon={<ModalCloseIco />}
                    centered
                    visible={codeModalVisible}
                    onOk={() => setCodeModalVisible(false)}
                    onCancel={() => setCodeModalVisible(false)}
                    width={700}
                    className={'manage_faster_menus swift_modal'}
                    keyboard={false}
                    focusTriggerAfterClose={false}
                    footer={false}
                  >
                    <Form
                      layout="vertical"
                      onFinish={(e) => {}}
                      autoComplete="off"
                    >
                      <table
                        className={'table table-hover swift_table b_code_table'}
                      >
                        <thead>
                          <tr>
                            <th>
                              <InputField
                                labelItem={t('newTransfer.bicCode')}
                                isNumeric={true}
                                onlyNumber={true}
                                placeholder={t('newTransfer.atLeast2Char')}
                                className={
                                  'hide_placeholder_on_focus input-border-modal'
                                }
                                name={'bikCode'}
                                suffix={
                                  <Button
                                    type={'ghost'}
                                    className={'transparent'}
                                    icon={<InputSearchIco />}
                                  />
                                }
                                onKeyUp={() => {
                                  updateBicCodesFilter()
                                }}
                                value={formFields?.bikCode}
                                form={form}
                              />
                            </th>

                            <th>
                              <InputField
                                labelItem={t('requisites.name')}
                                placeholder={t('transfers.atLeast3Char')}
                                className={
                                  'hide_placeholder_on_focus input-border-modal'
                                }
                                name={'bikName'}
                                suffix={
                                  <Button
                                    type={'ghost'}
                                    className={'transparent'}
                                    icon={<InputSearchIco />}
                                  />
                                }
                                onKeyUp={() => {
                                  updateBicCodesFilter()
                                }}
                                form={form}
                              />
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {bicCodes?.map((row) => {
                            return (
                              <tr
                                onClick={() => {
                                  updateToBicCodeAndName(row)
                                }}
                              >
                                <td>{row.BIC_CODE}</td>
                                <td>{row.BANK_NAME}</td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </Form>
                  </Modal>
                </div>

                <InputField
                  labelItem={t('requisites.name')}
                  placeholder=""
                  allowAllSymboll={true}
                  form={form}
                  name={'BENEFBANKNAME'}
                  value={formFields?.BENEFBANKNAME}
                  className={'isReadOnly'}
                  readOnly={true}
                />

                <InputField
                  labelItem={t('newTransfer.correspondentAccount')}
                  placeholder=""
                  form={form}
                  name={'BENEFBANKCORACC'}
                  value={formFields?.BENEFBANKCORACC}
                  className={'isReadOnly'}
                  readOnly={true}
                />

                <InputField
                  labelItem={t('newTransfer.addressCity')}
                  placeholder=""
                  name={'BENEFBANKADDR'}
                  form={form}
                  value={formFields?.BENEFBANKADDR}
                  className={'isReadOnly'}
                  allowAllSymboll={true}
                  readOnly={true}
                />

                <Divider className="no_text" />

                <div className={'flex'}>
  <div
    className="amount_and_commission_col"
    style={{
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <AmountField
      labelItem={t('common.amount')}
      placeholder=""
      suffix={'RUB'}
      name={'AMOUNT'}
      className={`amount_input isDisabled amntDgk`}
      required={true}
      form={form}
      disabled={!fromBranch?.ACCOUNT_NO}
      onBlur={calculateCommission}
      limit={9}
    />

    {hasDgkAmountError ? (
      <div
        style={{
          color: '#ff4d4f',
          fontSize: '12px',
          lineHeight: '20px',
          marginTop: '-10px',
          marginLeft: '190px',
          marginBottom: '12px',
        }}
      >
            {(dgkData.type === "Avans" || dgkData.type === "AVANS")? t('dgk.total_less_than_avans'):dgkData.type === "AKT"?t('dgk.total_less_than_akt'):t('dgk.total_less_than_gb')}

      </div>
    ) : null}
  </div>

  <Col className={'commission_col mobile-select dgkEditBox'}>
    <InputField
      labelCol={2}
      labelItem={t('home.commission')}
      placeholder=""
      className="dark-input commission_input isReadOnly commission_border dgkEdit"
      readOnly={true}
      suffix={'RUB'}
      name={'COMMAMOUNT'}
      value={commissionAmount}
      hasLoading={commissionLoading}
      form={form}
      required={true}
      message={''}
      notValid={form.getFieldValue('COMMAMOUNT') == ''}
    />
  </Col>
</div>

                <div className={'flex'}>
                  <SelectField
                    labelItem={t('dgk.payment_terms')}
                    placeholder={t('dgk.common.select')}
                    options={paymentOptions}
                    value={paymentConditionValue}
                    name={'paymentCondition'}
                    onChange={(e: any) => {
                      selectCondition(e)
                    }}
                    required={true}
                    form={form}
                    disabled={!form.getFieldValue('AMOUNT')}
                    className = "selectionFieldDgk"
                  />
                  <div className="btn-space">
                    {conditions.map((c) => {
                      const isSelected = dgkData?.type === c

                      return (
  <div className="dgkButtonWrapper">
    <Button
      key={c}
      disabled={activeCondition !== c}
      onClick={() => setOpenDgkModal(true)}
      className={`baseClass 
        ${activeCondition === c ? 'mustSelect' : ''} 
        ${isSelected ? 'dgkSelected' : ''}
      `}
    >
      {c === 'YGB' ? (
        t('dgk.ygb')
      ) : c === 'AKT' ? (
        t('dgk.akt')
      ) : (
        t('dgk.advance')
      )}
    </Button>

    {c === 'YGB' &&
      dgkData?.type === 'YGB' &&
      dgkData.pages?.length > 0 && (
        <span className="dgkCountBadge">
          {dgkData.pages.length}
        </span>
      )}

    {c === 'AKT' &&
      dgkData?.type === 'AKT' &&
      dgkData.pages?.length > 0 && (
        <span className="dgkCountBadge">
          {dgkData.pages.length}
        </span>
      )}

    {c === 'Avans' &&
      dgkData?.type === 'Avans' &&
      dgkData.contracts?.length > 0 && (
        <span className="dgkCountBadge">
          {dgkData.contracts.length}
        </span>
      )}
  </div>
);
                    })}
                  </div>
                </div>

                <FormItem required label={t('salary.documents')}>
                  <div className="flex items-center justify-between valyuta-footer">
                    <div
                      className="documentsIco"
                      style={{ display: 'flex', height: 50, alignItems: 'center' }}
                    >
                      <InputField
                        form={form}
                        name={'transferDocs'}
                        placeholder=""
                        style={{ width: 0, height: 0, position: 'fixed' }}
                        readOnly={true}
                        required={false}
                      />

                      <Button
                        size={'large'}
                        icon={<DocumentsIco className="" />}
                        disabled={!fromBranch}
                        className={`${
                          (documentsCount === 0 ||
                            documentsCount === null ||
                            documentsCount === undefined) &&
                          fromBranch
                            ? 'warning-button'
                            : !fromBranch
                            ? 'disable-button'
                            : 'light-button'
                        } refresh_btn btn flex align_center justify_center`}
                        onClick={(e) => {
                          setDocumentsModalVisible(true)
                        }}
                      >
                        {t(OWNACCOUNT.DOCUMENTS) + ' ('}
                        <span className="count">{documentsCount}</span>
                        {')'}
                      </Button>
                    </div>
                    <div style={{ alignContent: 'center' }}>
                      <p className="textFC">{t('transfers.documentInform')}</p>
                    </div>
                  </div>
                </FormItem>

                <TextAreaField
                  visible={true}
                  labelItem={t('accountStatement.paymentDetails')}
                  placeholder={t('notification.detailPlaceholder')}
                  showCount={true}
                  maxLength={'339'}
                  name={'PMTDET'}
                  required={true}
                  form={form}
                  // value={savedDocuments !== '' && documentsCount !== 0 ?
                  //    (savedDocuments?.length > 339 ? 
                  //     savedDocuments.substring(0, 339) : savedDocuments) 
                  //     : ""
                  //   }
                  allowRus={true}
                  readOnly={!fromBranch?.ACCOUNT_NO}
                  className={'isDisabled is_upper_case'}
                  upper={true}
                />

                {/* <TextAreaField
                  visible={true}
                  labelItem={t('transfers.infoForBeneficiary')}
                  placeholder={t('notification.detailPlaceholder')}
                  showCount={true}
                  maxLength={'195'}
                  name={'INFOTOBENEF'} 
                  form={form}
                  value={
                    savedDocuments !== '' && documentsCount !== 0
                      ? savedDocuments?.length > 129
                        ? savedDocuments?.length > 324
                          ? savedDocuments.substring(129, 324)
                          : savedDocuments.substring(129, savedDocuments?.length)
                        : ''
                      : ''
                  }
                  allowRus={true}
                  readOnly={!fromBranch?.ACCOUNT_NO}
                  className={'isDisabled is_upper_case'}
                /> */}

                <div className={'flex'}>
                  <Col flex={1}>
                    <TextAreaField
                      visible={visible}
                      className="not-required plus_minus_area isDisabled"
                      labelItem={t('newTransfer.note')}
                      placeholder={t('newTransfer.notTransferableToBank')}
                      showCount={true}
                      maxLength={'180'}
                      name={'NOTE'}
                      form={form}
                      readOnly={!fromBranch?.ACCOUNT_NO}
                      allowRus={true}
                    />
                  </Col>
                  <Button
                    className="icon-button add-remove-btn"
                    icon={visible ? <MinusSmallIco /> : <PlusSmallIco />}
                    onClick={() => setVisible(!visible)}
                  />
                </div>

                <FileUpload
                  className="file-upload isDisabled"
                  labelItem={t('newTransfer.attachPDF')}
                  accept="application/pdf"
                  multiple={false}
                  required={false}
                  form={form}
                  name={'pdf_files'}
                  onChange={getFileList}
                  fileLimit={10}
                  checkSize={true}
                  disabled={!fromBranch?.ACCOUNT_NO}
                  editFileList={fileList}
                  ibankRef={ibankRef}
                  editOrRepeat={editOrRepeat}
                  removeFile={removeFile}
                />

                {!addOrEditPage && (
                  <div className="flex button_row">
                    <Button
                      size={'large'}
                      icon={<SaveBlueIco />}
                      className="light-button btn save_btn flex align_center justify_center"
                      htmlType={'button'}
                      onClick={openSaveAsTemplateModal}
                    >
                      {OWNACCOUNT.SAVE}
                    </Button>

                    <div className={'flex flex_wrap valyuta-footer'}>
                      <div className="documentsIco"></div>

                      <Button
                        size={'large'}
                        icon={<RefreshIco />}
                        className="light-button refresh_btn btn flex align_center justify_center"
                        onClick={(e) => {
                          setOpenDgkModal(false)
                          dispatch(setDgkData(null))
                          setDgkModalKey((prev) => prev + 1)
                          setActiveCondition('')
                          setPaymentConditionValue(undefined)
                          setDocumentsCount(0)
                          resetFormFields()
                          resetForm(form)
                          form.setFieldsValue({
                            paymentCondition: undefined,
                          })
                          saveDocumentsModal(dataDocumentModal)
                        }}
                      >
                        {t(OWNACCOUNT.REFRESH)}
                      </Button>

                      <Button
                        size={'large'}
                        disabled={
                          (
                            (
                              documentsCount === 0 ||
                              documentsCount === null ||
                              documentsCount === undefined
                            ) &&
                            !form.getFieldValue('BENEFACC')?.startsWith('AZ')
                          ) ||
                          !isDgkCompleted() ||
                          hasDgkAmountError
                        }
                        htmlType="submit"
                        className="blue-button next_btn btn flex align_center justify_center"
                      >
                        {OWNACCOUNT.NEXT}
                      </Button>
                    </div>
                  </div>
                )}
              </Form>
            </Row>
          </Card>
        </Col>
      </Row>

      <DocumentsModal
        visible={documentsModalVisible}
        title={t('modal.modalTitleDocs')}
        children={<h1>documents modal</h1>}
        onCancel={(e, savedDocuments, createDocument) => {
        
          setcreateData(createDocument)
          setSaveDocuments(savedDocuments)
          setDocumentsCount(e)
          setDocumentsModalVisible(false)
          form.setFieldsValue({
            transferDocs: createDocument,
          })
          updateParentComponentFormData()
        }}
        rub={true}
        dataModal={documentsModalData}
        onDisabled={() => setDocumentsCount(0)}
        className='documents_modal'
        onSuccessClose={(bool, e, savedDocuments, createDocument) => {
          setDocumentsModalVisible(bool)
          if (savedDocuments?.length > 0) { form.setFieldsValue({ 
            "PMTDET": savedDocuments !== '' && documentsCount !== 0 ? 
            (savedDocuments?.length > 339 ? 
              savedDocuments.substring(0, 339) :
               savedDocuments) : "" }) }
          
        }}
        saveDocumentsModal={(savedDocuments: any) => {
           saveDocumentsModal(savedDocuments)
         }}
      />

      <NextModal
        errorIcon={<EroorIco />}
        callBackApi={newTransferFunc}
        visible={nextModalVisible}
        onClose={() => { setNextModalVisible(false); }}
        data={modalData}
        currencyModalData={createData}
        onCloseSuccessModal={() => {
          onCloseSuccessModal()
        }}
        nextModalTitle={t('home.transfer')}
        nextModalText={`Əməliyyat uğurla saxlanılmış, imzalanmışdır və banka göndərilməsini gözləməkdədir.`}
        currentForm={form}
        transfer={true}
        repeatPdfList={fileList}
        tableData={tableData}
        editTransfer={
          ibankRef !== undefined && ibankRef !== '' && ibankRef !== null
        }
      />

      {openDgkModal && (
        <DgkModal
          key={`${activeCondition}-${dgkModalKey}`}
          visible={openDgkModal}
          setVisible={setOpenDgkModal}
          transferKind={activeCondition}
          onClose={() => setOpenDgkModal(false)}
          iban={fromBranch?.IBAN}
          transferAmount={!isNaN(Number(transferAmount)) ? Number(transferAmount) : 0}
          toConvert={toConvert}
        />
      )}

      <TemplatePopup
        visible={templatePopupVisible}
        onClose={setTemplatePopupVisible}
        trnType={'SWIFT_RUB'}
        currentForm={form}
        updateAfterTemplate={updateDocumentNumberAndCommission}
      />

      <SaveAsTemplate
        visible={saveAsTemplatePopupVisible}
        onClose={setSaveAsTemplatePopupVisible}
        trnType={'SWIFT_RUB'}
        transferDocs={documentsData}
        currentForm={form}
      />

      {loadingData ? <FullScreenLoading /> : <></>}
    </>
  )
}


const mapDispatchToProps = { setIbanNumber }

const mapStateToProps = (state: any, ownProps: any) => ({
  ownProps: ownProps,
  ibanNumber:
    state.accountsStatement && state.accountsStatement.ibanNumber
      ? state.accountsStatement.ibanNumber
      : {},
})

export default connect(mapStateToProps, mapDispatchToProps)(Rub)